import type { ButtonHTMLAttributes } from 'react';
import { cn } from './cn.js';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  tone?: 'default' | 'danger' | 'gold';
  size?: 'sm' | 'md' | 'lg';
}

const tones = {
  default: 'text-text-dim hover:bg-raise-2 hover:text-text',
  danger: 'text-danger hover:bg-danger/15',
  gold: 'text-gold hover:bg-gold/10',
};

const sizes = {
  sm: 'w-9 h-9',
  md: 'w-11 h-11',
  lg: 'w-12 h-12',
};

export function IconButton({ tone = 'default', size = 'md', className, ...rest }: IconButtonProps) {
  return (
    <button
      {...rest}
      className={cn(
        'inline-flex items-center justify-center rounded-xl transition active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/40',
        tones[tone],
        sizes[size],
        className,
      )}
    />
  );
}
